export default __webpack_public_path__ + "static/media/drello_1.303c18fe.jpg";